export const GET_PROMOTIONS = "GET_PROMOTIONS"
export const GET_PROMOTIONS_LOADING = "GET_PROMOTIONS_LOADING"
export const GET_PROMOTIONS_SUCCESS = "GET_PROMOTIONS_SUCCESS"
export const GET_PROMOTIONS_ERROR = "GET_PROMOTIONS_ERROR"

export const getPromotions = (body) => ({ type: GET_PROMOTIONS, body })